import { render, staticRenderFns } from "./Periode.vue?vue&type=template&id=e62d2c14&"
import script from "./Periode.vue?vue&type=script&lang=js&"
export * from "./Periode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports